import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
export function DataTable({ columns, data, rowKey, initialSort, emptyMessage = "No data", onRowClick, rowClassName, className = "", }) {
    const [sort, setSort] = React.useState(initialSort ?? null);
    const sorted = React.useMemo(() => {
        if (!sort)
            return data;
        const column = columns.find((c) => c.key === sort.key);
        if (!column?.sortValue)
            return data;
        const dir = sort.direction === "asc" ? 1 : -1;
        const withValues = data.map((row) => ({ row, value: column.sortValue(row) }));
        withValues.sort((a, b) => {
            if (a.value == null && b.value == null)
                return 0;
            if (a.value == null)
                return 1;
            if (b.value == null)
                return -1;
            if (a.value < b.value)
                return -1 * dir;
            if (a.value > b.value)
                return 1 * dir;
            return 0;
        });
        return withValues.map((entry) => entry.row);
    }, [data, sort, columns]);
    function toggleSort(column) {
        if (!column.sortValue)
            return;
        setSort((prev) => {
            if (!prev || prev.key !== column.key)
                return { key: column.key, direction: "asc" };
            if (prev.direction === "asc")
                return { key: column.key, direction: "desc" };
            return null;
        });
    }
    return (_jsx("div", { className: ["overflow-x-auto", className].join(" "), children: _jsxs("table", { className: "min-w-[640px] w-full divide-y divide-zinc-200 text-sm", children: [_jsx("thead", { className: "bg-zinc-50/80", children: _jsx("tr", { children: columns.map((column) => {
                            const isSorted = sort?.key === column.key;
                            const sortable = Boolean(column.sortValue);
                            return (_jsx("th", { scope: "col", "aria-sort": isSorted ? (sort.direction === "asc" ? "ascending" : "descending") : undefined, className: [
                                    "h-10 px-3 text-left text-[0.6875rem] font-semibold uppercase tracking-wider text-zinc-500 sm:h-11 sm:px-4",
                                    sortable ? "cursor-pointer select-none hover:text-zinc-700" : "",
                                    column.className ?? "",
                                ].join(" "), onClick: () => toggleSort(column), children: _jsxs("span", { className: "inline-flex items-center gap-1", children: [column.header, sortable ? (_jsx("span", { className: "text-zinc-400", "aria-hidden": true, children: isSorted ? (sort.direction === "asc" ? "▲" : "▼") : "↕" })) : null] }) }, column.key));
                        }) }) }), _jsx("tbody", { className: "divide-y divide-zinc-100 bg-white", children: sorted.length === 0 ? (_jsx("tr", { children: _jsx("td", { colSpan: columns.length, className: "px-4 py-6 text-center text-zinc-400", children: emptyMessage }) })) : (sorted.map((row) => (_jsx("tr", { className: ["transition-colors", onRowClick ? "cursor-pointer hover:bg-zinc-50/80" : "", rowClassName?.(row) ?? ""].join(" "), onClick: () => onRowClick?.(row), children: columns.map((column) => (_jsx("td", { className: ["px-3 py-2.5 text-zinc-700 sm:px-4 sm:py-3", column.className ?? ""].join(" "), children: column.accessor(row) }, column.key))) }, rowKey(row))))) })] }) }));
}
